import { useEffect, useState } from 'react';
import { realtime, type AgentEvent, type ConnectionState } from './ws';

/** Возвращает текущее состояние WS-соединения. */
export function useRealtimeState(): ConnectionState {
  const [state, setState] = useState<ConnectionState>(realtime.getState());
  useEffect(() => realtime.onState(setState), []);
  return state;
}

export interface InboxEntry extends Object {
  id: string;
  at: string;
  event: AgentEvent;
}

const INBOX_MAX = 50;

/**
 * Локальный inbox: последние N событий. Хранится в памяти (не sessionStorage —
 * пусть сбрасывается на reload, не путаем юриста старыми уведомлениями).
 */
const listeners = new Set<(items: InboxEntry[]) => void>();
let entries: InboxEntry[] = [];

let unsub: (() => void) | null = null;
function ensureSubscribed() {
  if (unsub) return;
  unsub = realtime.subscribe((event) => {
    // hello-фрейм не складываем — это не «событие» в смысле inbox.
    if (event.event === 'connected') return;
    const at = 'at' in event && typeof event.at === 'string' ? event.at : new Date().toISOString();
    const entry: InboxEntry = {
      id: `${at}-${event.event}-${Math.random().toString(36).slice(2, 8)}`,
      at,
      event,
    };
    entries = [entry, ...entries].slice(0, INBOX_MAX);
    for (const l of listeners) l(entries);
  });
}

export function useInbox(): InboxEntry[] {
  ensureSubscribed();
  const [items, setItems] = useState<InboxEntry[]>(entries);
  useEffect(() => {
    listeners.add(setItems);
    return () => {
      listeners.delete(setItems);
    };
  }, []);
  return items;
}

export function clearInbox() {
  entries = [];
  for (const l of listeners) l(entries);
}
